import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip, Icon, Typography, IconButton } from "@material-ui/core";

import { HOME_TAB } from "../../../../util/Constants";
import { useStyles, iconAuto } from "./styles";

export default function HomeTabButton(props) {
  const { activeTab, handleTabClick, sidebarOpen } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Tooltip title={t("TAB_HOME")} placement="right">
      <div className={classes.envButton}>
        <IconButton
          id="tab_home_button"
          className={
            activeTab === HOME_TAB ? classes.activeTab : classes.normalTab
          }
          onClick={() => {
            handleTabClick(HOME_TAB, false);
          }}
        >
          <Icon className="fas fa-home" style={iconAuto} />
        </IconButton>
        {sidebarOpen && <Typography>{t("TAB_HOME")}</Typography>}
      </div>
    </Tooltip>
  );
}
